import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PassagensService } from '../passagens-service/passagens.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-passagens-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./passagens-lista.component.css']
})
export class PassagensListaComponent
extends ListaBase 
implements OnInit {
visualizarTotalRegistros: boolean;
exibirBotaoDetalhes: boolean;

  constructor(service: PassagensService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("nome_categoria_passagens", 'parametros.passagens.categoriaPassagens')
      .addColuna("ano", 'parametros.passagens.ano')
      .addColuna("mes", 'parametros.passagens.mes')
      .addColuna("valor", 'parametros.passagens.valor')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
    || this.filtros.mes
    || this.filtros.ano
    || this.filtros.id_dealer
    || this.filtros.id_categoria_passagens;
  }
}
